import { FormControl, ValidationErrors } from '@angular/forms';

export function passwordValidator(control: FormControl): ValidationErrors {
  return new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$&()*\\-`._+,])[A-Za-z\\d!@#$&*()\\-`._+,]{8,}').test(
    control.value,
  )
    ? null
    : { password: true };
}
